/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {


    var $footerNav = $('footer.main-footer .footer-nav'),
        $header = $('header.top-header'),
        scrolled = 0,
        scrollNav = $.noop(),
        $body = $('body'),
        $navItemsWithChildren = $('nav.nav-primary ul.nav > li.menu-item-has-children'),
        navOpend = false,
        clicked = false,
        $navbarheight
        ;

    var hash = "";


    $footerNav.on('click', '.title', function (e) {
        e.preventDefault();
        var $mobileNav = $(e.currentTarget).closest('div').find('.mobile-footer-nav');

        if (window.matchMedia("(max-width: 767px)").matches) {
            if ($mobileNav.hasClass('open')) {
                $footerNav.find('.mobile-footer-nav, .title').removeClass('open');
            } else {
                $footerNav.find('.mobile-footer-nav, .title').removeClass('open');
                $mobileNav.addClass('open');
                $(this).addClass('open');
            }
            return;
        } else {
            return;
        }
        $mobileNav.toggleClass('open');

    });

    //https://davidwalsh.name/javascript-debounce-function

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    function isMobile() {
        if (window.matchMedia("(max-width: 991px)").matches) {
            return true;
        }
        return false;
    }

    function isMobilesmall() {
        if (window.matchMedia("(max-width: 767px)").matches) {
            return true;
        }
        return false;
    }

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                // Anchor click smooth scroll

                $('a[href*="#"]:not([href="#"])').click(function (event) {
                    event.preventDefault();
                    $('html, body').stop();
                    var hashLink = $(this).attr('href');
                    //console.log(hashLink);
                    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                        var target = $(this.hash);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            history.pushState({}, '', this.href);
                            var jumpPoint = $(target);
                            var scrollDistance = Math.abs(jumpPoint.offset().top - $(window).scrollTop());
                            $('.navbar-collapse').collapse('hide');
                            $('#menu-main > li').removeClass('active');
                            $(event.currentTarget).parent().addClass('active');
                            $navbarheight = (isMobilesmall() || (isMobile() && $header.hasClass('sticky'))) ? $header.outerHeight() - $('.menu-main-container').parent('.navbar-collapse').outerHeight() : $header.outerHeight();
                            //console.log($navbarheight);

                            if ($navbarheight < 0) {
                                $navbarheight = $header.outerHeight();
                            }

                            $('html, body').animate({
                                scrollTop: target.offset().top - $navbarheight
                            }, (500 + scrollDistance / 5));
                            return false;

                        }
                    } else {
                        //console.log(hashLink);
                        window.location.href = hashLink;
                    }
                });

                // Dropdown Menu

                dropdown_trigger = $('nav.nav-primary ul.nav > li.menu-item-has-children');

                dropdown_trigger.click(function () {
                    var that = this;

                    if (isMobile()) {
                        $(this).find('.sub-menu-wrap').collapse('show');
                    }

                    $(this).toggleClass('active');
                    navOpend = false;
                    if ($(this).hasClass('active')) {
                        navOpend = true;
                    }
                    dropdown_trigger.each(function () {
                        if (this !== that) {
                            $(this).removeClass('active');
                        }
                        if (isMobile()) {
                            $(this).find('.sub-menu-wrap').collapse('hide');
                        }
                    });

                });

                // Scrolling Events

                if (window.matchMedia("(max-width: 767px)").matches) {
                    scrollNav = debounce(function () {
                        var scrollTop = $(window).scrollTop();
                        var $nav = $('.nav-primary');
                        var $metaMenu = $('.nav-top');
                        var $paddingtop = $header.hasClass('sticky') ? $header.outerHeight() - $('.menu-main-container').parent('.navbar-collapse').outerHeight() : $header.outerHeight();

                        if (scrollTop > $metaMenu.height()) {
                            $body.css({ paddingTop: $paddingtop });
                            $header.addClass('sticky');
                        } else {
                            $body.css({ paddingTop: 0 });
                            $header.removeClass('sticky');
                        }

                        if ((scrollTop > scrolled) && (scrollTop > 200)) {
                            $header.addClass('dismissed');
                            // TODO: close all open menu items
                            $nav.find('.sub-menu-wrap').collapse('hide');
                            $nav.find('.navbar-collapse').collapse('hide');
                            //console.log("close open tabs");
                        } else {
                            $header.removeClass('dismissed');
                        }
                        scrolled = scrollTop;

                    }, 10);
                } else {
                    scrollNav = function () {
                        var headerTop = $header.offset().top;
                        var scrollTop = $(window).scrollTop();
                        var $metaMenu = $('.nav-top');
                        var $paddingtop = $header.hasClass('sticky') ? $header.outerHeight() - $('.menu-main-container').parent('.navbar-collapse').outerHeight() : $header.outerHeight();

                        if (scrollTop > $metaMenu.height()) {
                            $body.css({ paddingTop: $paddingtop });
                            $header.addClass('sticky');
                        } else {
                            $body.css({ paddingTop: 0 });
                            $header.removeClass('sticky');
                        }
                    };
                }


                $(window).on('scroll', scrollNav);

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
                //                hash = window.location.hash.substr(0);
                //                if (hash !== "") {
                //                    window.location.href = window.location.href.replace(/#.*/, '#');
                //                }
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
                //                $(window).bind('load', function () {
                //                    if (hash !== "") {
                //                        $('html, body').animate({
                //                            scrollTop: $(hash).offset().top - $header.outerHeight()
                //                        }, 1000);
                //                        return false;
                //                    }
                //
                //                });
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };


    //var $bg = $(".banner");
    //var resizeBG = function resizeBackground() {
    //    $bg.height($(window).height() * 0.7 - 97);
    //}
    //$(window).on('resize', resizeBG);
    //resizeBG();


    $body.on('mouseup', function (e) {
        e.preventDefault();
        $ele = $(e.target);

        if (navOpend && !($('ul#menu-main').has($ele).length)) {
            $navItemsWithChildren.removeClass('active');

        }

    });



    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
